const {ccclass, property} = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit, implementFunction } from "../../../../framework/core/mvvm/module_base";
import PlayerIconView from "./playerIcon_view";
import ModelData, { IUserData } from '../../../public/model_data';
import UserDataManager, { IUserCurrencyData } from '../../../../manager/user_manager';
import GameUtil from "../../../../utility/game_util";
import AppController from "../../../../sdk/app_controller";
import OssManager from "../../../../manager/oss_manager";
import Utility from "../../../../utility/utility";
import * as CryptoJS from 'crypto-js';
import PromiseUtility from "../../../../utility/promiseUtility";
import SceneManager from "../../../../manager/scene_manager";
import Rule from "../rule/rule";
import ModuleManager from "../../../../framework/core/module_manager";
import { joinUtil } from "../../../public/join_util";
import { friend_utils } from "../friend/friend_utils";
import Bag from "../bag/bag";
import Shop from "../shop/shop";
import AppData from "../../../public/const/app_data";

@ccclass
@moduleInit("PlayerIconModule")
export default class PlayerIconModule extends ModuleBase<PlayerIconView, null> {

    private photoData:any = null;
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.viewType = PlayerIconView;
        this.needDeferShow = true
        this.initModule(true,true,true)
    }

    protected initModule(isWidth,needAnim,needViewMask){
        let path = isWidth?'Public_WindowPlayerIcon':'Public_PlayerIcon_width';
        this.windowPrefabResPath = "package/hall/module/playericon/"+path;
        this.needAnim = needAnim;
        this.needViewMask = needViewMask;
    }

    onInit() {
        this.view.clickIconNode.on('click',()=>{
            this.canclePhoto();
            if (AppData.inTable) {
                if (!this.getIsRole()) {
                    this.view.showBigIcon(true);
                }
            }else{
                if (this.getIsRole()) {
                    //this.view.siwtchPanel('playerIcon');
                }else{
                    this.view.showBigIcon(true);
                }
            }
        })

        this.eventBind('OnShowPhotoCallback',this.receivePhoto)
        this.eventBind('OnCancelPhotoCallback',this.canclePhoto)
        this.eventBind('_click_game_item_',this.clickItem);
        this.eventBind('buy_vip_event',this.updateVipList)
        this.eventBind('_on_hide_playerInfo_',this.onHidePlayerInfo)
        this.view.init();
        this.view.updateContentLayout();
    }

    userId:number;

    receivePhoto(data:any){
        if (data && this.nodeIsValid) {
            let self = this;
            this.photoData = data;
            let strImg = "data:image/jpg;base64," + data.img.toString();
            let img = new Image();
            img.src = strImg
            let texture = new cc.Texture2D();
            texture.initWithElement(img);
            texture.handleLoadedTexture();
            self.view.setSelectImage(texture,null);
        }
    }

    canclePhoto(){
        this.photoData = null;
    }

    clickItem(gameid:string){
        this.hide();
        ModuleManager.instance.hideModule('Rank')
        joinUtil.openGoleEntrance(gameid)
    }

    protected uploadJpg(){
        cc.log('photo uploadJpg')
        if (!this.photoData) {
            return;
        }

        let str = this.photoData.img.toString();
        if (!str) {
            return;
        }

        let name = CryptoJS.MD5(this.photoData.img).toString();
        let key = name + '.jpg'

        var base64 = this.photoData.img
        let raw = Utility.atob(base64);

        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for(let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }

        let uploadTimes = 3 //上传失败后的重试次数
        let self = this;
        OssManager.instance.upload_jpg(key, array, function(url){
            if (self.nodeIsValid) {
                self.changeIcon(url,ModelData.instance.roleData.gender);
            }
        }, function(){}, uploadTimes)
    }

    protected stringToUint8Array(str){
        var arr = [];
        for (var i = 0, j = str.length; i < j; ++i) {
          arr.push(str.charCodeAt(i));
        }
        var tmpUint8Array = new Uint8Array(arr);
        return tmpUint8Array
      }

    protected onDeferShow(arg){
        let isOther = false;
        let showSmallIcon = arg && arg.isShowSmallIcon
        this.userId = (arg && arg.userId) ? arg.userId:ModelData.instance.roleData.id
        isOther = this.userId != ModelData.instance.roleData.id
        
        let self = this;
        let refreshPlayerInfo = (cb)=>{
            self.getUserData(self.userId,(userdata:IUserData)=>{
                if (self.nodeIsValid) {
                    if (isOther) {
                        self.view.refreshOtherInfo(userdata);
                    }else{
                        self.view.refreshPlayerInfo(userdata);
                      
                    }
                    self.view.refreshCommon(userdata);
                    cb()
                }
            },true)
        }

        let refreshPlayerMoney = (cb)=>{
           this.getPlayerMoney(cb);
        }

        let refreshHistory = (cb)=>{
            this.getHistoryInfo(cb);
        }

        let friendReq = (cb)=>{
            if (this.getIsRole()) {//自己
                cb();
            }else{//其他需要请求 0:是好友 1:发送过申请 2: 不是好友
                this.updateFriendState(cb);
            }
        }

        PromiseUtility.all([refreshPlayerInfo,refreshPlayerMoney,refreshHistory,friendReq]).then(()=>{
            if (showSmallIcon) {
                if (self.getIsRole()) {
                    self.view.siwtchPanel('playerIcon');
                }
            }
            self.show();
        })

        this.view.showPanelIsInGame(AppData.inTable,this.getIsRole(),isOther);
    }

    private updateVipList(){
        let self = this;
        if (!this.getIsRole()) {
            return;
        }
        self.getUserData(ModelData.instance.roleData.id,(userdata:IUserData)=>{
            if (self.nodeIsValid) {
                self.view.refreshPlayerInfo(userdata);
            }
        },true)
    }

    private getPlayerMoney(cb){
        let self = this;
        if (ModelData.instance.roleData.id && ModelData.instance.roleData.id == self.userId) {
            UserDataManager.getCurrencyData(self.userId,(currencyData: IUserCurrencyData)=>{
                if (self.nodeIsValid) {
                    self.view.refreshPlayerMoney(currencyData);
                    cb()
                }
            },true,true)
        }else{
            UserDataManager.getOtherCurrencyData(self.userId,(currencyData: IUserCurrencyData)=>{
                if (self.nodeIsValid) {
                    self.view.refreshPlayerMoney(currencyData);
                    cb()
                }
            })
        }
    }

    private getIsRole(){
        return this.userId == ModelData.instance.roleData.id;
    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(currencyData: IUserCurrencyData){
        let self = this
        if (this.userId == ModelData.instance.roleData.id) {
            self.view.refreshPlayerMoney(currencyData);
        }
    }

    onButtonClick(node: cc.Node){
        let name = node.name;
        if (name.startsWith('gray')) {
            //cc.log('goto Vip');
            if (this.getIsRole()) {
                ModuleManager.instance.showModule<Shop>(Shop, {tag: "tag_vip"})
            }
        }
    }

    @bindButtonClickEvent('nv_btn')
    protected clickSexFemaleBtn(){
        this.view.refreshItemList(false);
        this.view.refreshGender(2);
        this.openEditorPanel(2);
    }

    @bindButtonClickEvent('bagbtn')
    bagbtnFunc(){
        ModuleManager.instance.showModule<Bag>(Bag,{tag: 'tag_daoju'})
    }

    @bindButtonClickEvent('nan_btn')
    protected clickSexMaleBtn(){
        this.view.refreshItemList(true);
        this.view.refreshGender(1);
        this.openEditorPanel(1);
    }

    openEditorPanel(gender:number){
        let user = ModelData.instance.roleData;

        if (user.avatar && user.avatar.indexOf("http") == -1) {//属于系统头像
            let data = this.view.selectFirstHead(gender==1);
            if (data) {
                if (user.gender != gender) {
                    this.changeIcon(data.iconName,data.isMale ? 1:2);
                }
            }
        }else{
            if (user.gender != gender) {//自选头像只会更改性别
                this.changeIcon(user.avatar,gender);
            }
        }
    }


    //获取玩家战绩信息
    getHistoryInfo(cb){
        let self = this;
        let requestData = {
            baseUrl: "user/historyInfo?",
            params: {
                gameUserId:ModelData.instance.roleData.id,
                otherUserId:this.userId
            }
        }
        this.apiHttpGet(requestData, function (retData) {
            if (self.nodeIsValid) {
                let data = retData.data;
                self.view.updateMaxVectory(data.maxWinMongo,data.maxWinChip);
                self.view.updateJS(data.mongoRoundNum,data.chipRoundNum);
                self.view.updateMaxHistoryGold(data.maxAccountMongo,data.maxAccountChip);
                self.view.updateGameList(data)
                cb();
            }
        })
    }

    //处理类型
    onButtonSave() {
        if (this.photoData) {
            this.uploadJpg()
            return;   
        }
        let [iconName, gender] = this.view.getSelectData()
        this.changeIcon(iconName,gender);
    }

    changeIcon(iconName:string,gender:number){
        if (!iconName || !gender) {
            return;
        }

        this.view.refreshSelectPlayerIcon();

        this.reqChangeIcon(iconName, gender, ()=>
        {
            UserDataManager.getDataFromServer(ModelData.instance.roleData.id, ()=>{});
            this.eventDispatch('player_avatar_data_changed', ModelData.instance.roleData.id, true)
        })
    }

    changeName(){
        let editorName = this.view.eidtorBox.string;
        if (ModelData.instance.roleData.name == editorName
            || editorName.length == 0) {//同名
            return;
        }

        this.reChangeName(editorName,()=>{
            UserDataManager.getDataFromServer(ModelData.instance.roleData.id, ()=>{});
        })
    }

    @bindButtonClickEvent("btnClose")
    onButonClose()
    {
        if (!this.getIsRole()) {
            this.hide();
            return;
        }

        if (this.view.isShowImage) {
            this.view.siwtchPanel('baseInfo');
            this.onButtonSave();
        }else{
            this.changeName();
            this.hide();
        }
    }

    @bindButtonClickEvent('looklv')
    onButtonGotoLook(){
        ModuleManager.instance.showModule<Rule>(Rule, { isHall: true, isSys:true })
    }

    onHide(){
        if (this.view) {
            this.view.resetCache()
        }
    }

    @bindButtonClickEvent("localImage")
    onLocalImageBtn(){
        cc.log('photo')
        let size = this.view.avatarSize();
        AppController.instance.openAlbum(size.width+100,size.height+100);
    }

    @bindButtonClickEvent("photoimage")
    photoimageBtn(){
        cc.log('local camera')
        let size = this.view.avatarSize();
        AppController.instance.openCamera(size.width+100,size.height+100);
    }

    @bindButtonClickEvent('blackmask')
    clickMaskBtn(){
        this.view.showBigIcon(false);
    }

    @bindButtonClickEvent('addFriend')
    addFriend(){
        friend_utils.addFriend(this.userId,this,(result)=>{
            if (result) {
                this.updateFriendState();
            }
        })
    }

    @bindButtonClickEvent('deleteFriend')
    deleteFriend(){
        friend_utils.removeFriend(this.userId,this,(result)=>{
            this.view.refreshFriend(result ? 0:1)
        })
    }

    siwtchPanel(isIcon){
        if (!this.nodeIsValid) {
            return;
        }
        if (isIcon) {
             this.view.siwtchPanel('playerIcon');
        }else{
            this.view.siwtchPanel('baseInfo');
        }
    }

    reChangeName(nickname:string,callback){
        let requestData = {
            baseUrl: "user/editInfo?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
                nickname:nickname,
            }
        }
        let self = this;
        GameUtil.apiHttpGet(requestData, function (retData) {
            if (self.nodeIsValid) {
                if (callback) {
                    callback(retData.data)
                }
            } 
        })
    }

    reqChangeIcon(iconName: string,gender: number, callback) {
        let requestData = {
            baseUrl: "user/editInfo?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
                gender: gender,
                headImg: iconName,
            }
        }
        let self = this;
        GameUtil.apiHttpGet(requestData, function (retData) {
            if (self.nodeIsValid) {
                if (callback) {
                    callback(retData.data)
                }
            } 
        })
    }

    hideInfoSetting(){
        if (!this.getIsRole()) {
            return;
        }
        if (this.view.isShowImage) {
            this.view.siwtchPanel('baseInfo');
            this.onButtonSave();
        }
        this.changeName();
    }

    onHidePlayerInfo(){
        this.hideInfoSetting();
        this.view.cacheName = ''
    }


    updateFriendState(cb?:Function){
        friend_utils.isFriend(this.userId,this,(result)=>{
            this.view.refreshFriend(result ? 1:0)
            cb && cb();
        });
    }
}
